import type { SxProps, Theme } from '@mui/material';
import COLORS from '@/resources/style/Themes';

export type TierChipVariant = 'connect' | 'ops' | 'respond';

export type TierChipColors = {
  backgroundColor: string;
  color: string;
};

const TIER_CHIP_COLORS: Record<TierChipVariant, TierChipColors> = {
  connect: { backgroundColor: COLORS.CONNECT_BACKGROUND_GRAY, color: COLORS.CONNECT_TEXT_GRAY },
  ops: { backgroundColor: COLORS.BUTTON_BACKGROUND_BLUE, color: COLORS.SAFEGUARD_BLUE },
  respond: { backgroundColor: COLORS.BUTTON_BACKGROUND_GREEN, color: COLORS.DARK_GREEN },
};

const TIER_CHIP_BASE_SX: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: 15,
  px: 0.5,
  py: 2,
  borderRadius: 3,
};

export const getTierChipColors = (variant: TierChipVariant): TierChipColors =>
  TIER_CHIP_COLORS[variant];

export const getTierChipSx = (variant: TierChipVariant): SxProps<Theme> => ({
  ...getTierChipColors(variant),
  ...TIER_CHIP_BASE_SX,
});
